import { render, staticRenderFns } from "./ReviewsCedar.vue?vue&type=template&id=17d6ea46&scoped=true"
import script from "./ReviewsCedar.vue?vue&type=script&lang=js"
export * from "./ReviewsCedar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d6ea46",
  null
  
)

export default component.exports